<mat-card >
    <form *ngIf="!isLoading" class="form" [formGroup]="accountForm" autocomplete="off" (ngSubmit)="save(accountForm.value)">
        <mat-card-content>
            <p *ngIf="(auth.isGlobalAdmin|async)"><mat-form-field class="full-width" appearance="fill">
                <mat-label>Is Approved</mat-label>
                <mat-select class="full-width"  formControlName="isApproved">
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field></p>
            <!-- <p *ngIf="(auth.isGlobalAdmin|async)"><mat-form-field class="full-width" appearance="fill">
                <mat-label>Is Disabled</mat-label>
                <input #name matInput type="checkbox" formControlName="isApproved">
            </mat-form-field></p> -->
            <p *ngIf="(auth.isGlobalAdmin|async)"><mat-form-field class="full-width" appearance="fill">
                <mat-label>Licensed Retailer Count (-1 for unlimited)</mat-label>
                <input #name matInput type="text" formControlName="licensedRetailerCount" >
                <mat-error *ngIf="hasError('licensedRetailerCount', 'required')">Required</mat-error>
            </mat-form-field></p>
            <!-- <p *ngIf="(auth.isGlobalAdmin|async)"><mat-form-field class="full-width" appearance="fill">
                <mat-label>Licensed Location Count (-1 for unlimited)</mat-label>
                <input #name matInput type="text" formControlName="email" readonly>
                <mat-error *ngIf="hasError('email', 'required')">Email is required</mat-error>
                <mat-error *ngIf="hasError('email', 'email')">Email must be valid</mat-error>
            </mat-form-field></p> -->
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Email Address</mat-label>
                <input #name matInput type="text" formControlName="email" readonly>
                <mat-error *ngIf="hasError('email', 'required')">Email is required</mat-error>
                <mat-error *ngIf="hasError('email', 'email')">Email must be valid</mat-error>
            </mat-form-field></p>

            
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Account Name</mat-label>
                <input #name matInput type="text" formControlName="name">
                <mat-error *ngIf="hasError('name', 'required')">Name is required</mat-error>
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Phone Number</mat-label>
                <input matInput type="tel" mask="000-000-0000"  formControlName="phone">
                <mat-error *ngIf="hasError('phone', 'required')">Phone Number is required</mat-error>
                <mat-error *ngIf="hasError('phone', 'pattern')">Phone Number must be in the format ###-###-#####</mat-error>
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Address</mat-label>
                <input matInput type="text" placeholder="Address" formControlName="address1">
                <mat-error *ngIf="hasError('address1', 'required')">Address is required</mat-error>
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Address Line 2</mat-label>
                <input matInput type="text" placeholder="Address Line 2" formControlName="address2">
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Address Line 3</mat-label>
                <input matInput type="text" placeholder="Address Line 3" formControlName="address3">
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>City</mat-label>
                <input matInput type="text" placeholder="City" formControlName="city">
                <mat-error *ngIf="hasError('city', 'required')">City is required</mat-error>
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>State</mat-label>
                <input matInput type="text" placeholder="State" formControlName="state">
                <mat-error *ngIf="hasError('state', 'required')">State is required</mat-error>
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Postal Code</mat-label>
                <input matInput type="text" placeholder="Postal Code" formControlName="postal">
                <mat-error *ngIf="hasError('postal', 'required')">Postal is required</mat-error>
            </mat-form-field></p>
        
            <p><mat-form-field class="full-width" appearance="fill">
                <mat-label>Country</mat-label>
                <mat-select class="full-width"  formControlName="country">
                    <mat-option value=""></mat-option>
                    <mat-option value="US">United States</mat-option>
                </mat-select>
                
                <mat-error *ngIf="hasError('country', 'required')">Country is required</mat-error>
            </mat-form-field></p>
        
        </mat-card-content>
        <mat-card-actions>
            <button mat-raised-button color="primary" [disabled]="!accountForm.valid">Save</button>
            
          </mat-card-actions>
    </form>
    </mat-card>